

function ListStyleLI({ data, children, className, onClick }) {
  return (
    <li
      className={`${className || ""
        } list-disc marker:text-gleads-buttonBlue-500`}
      onClick={onClick}
    >
      {data || children}
    </li>
  );
}

export default ListStyleLI;
